const state = {
  escuela_data: [],
};

export default state;
